import React from "react";
import './SolarSerdan.css';
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import { FaWhatsapp } from 'react-icons/fa';
import { useInView } from "react-intersection-observer";
function SolarSerdan() {
     
    const {ref:wrapSS, inView:wrapSSIsVisible} = useInView({
        "threshold": .1,
        "initialInView":true
        })

    const {ref:imagen3, inView:image3IsVisible} = useInView({
        "threshold":.75,
        "initialInView":true
    })
    const {ref:txtSS, inView:txtSSIsVisible} = useInView({
        "threshold":.9,
        "initialInView":true
    })
    const {ref:cotizar, inView:cotizarIsVisible} = useInView({
        "threshold":.9,
        "initialInView":true
    })
    return (
        <div ref={wrapSS} class={`contentWrapSS ${wrapSSIsVisible ? "contentWrapSSAnimation" : ""}`} id="solarserdan">
            <div class="SolarSerdanFlexWrap">
                <div class="WrapTextSolarSerdan">
                    <div class="titleSolarSerdan">
                        <TitleDisplayerComponent text="Solar Serdán" id="SolarSerdanTxtTitle" />
                    </div>
                    <h4 ref={txtSS} className={`TxtContentSolarSerdan ${txtSSIsVisible ? "txtSSAnimated" : ""}`}>
                        <h3 id="BoldText">¿Te gustaría disminuir el monto en tus recibos de luz?</h3>
                        <br/>
                        La energía solar, además de ser mucho más barata, contribuye al cuidado del medio ambiente.<br />
                        <br />
                        Actualmente, el 70% de la energía eléctrica que consumimos en México se produce mediante la quema de combustibles fósiles.
                        Hoy en día, cada vez son más las empresas y domicilios partículares que optan por instalar <span id="PNText">páneles solares</span> para producir energía eléctrica mediante los rayos del sol.<br />
                        <br />
                        Únete a esta revolución ambiental, tus finanzas te lo agradecerán.,
                        fabricación de artículos de acero inoxidable y más.</h4>
                        
                        <div class="WrapWhapText">
                       
                        <div ref={cotizar} className={`CotizarWhap ${cotizarIsVisible ? "CotizarWhapAnimated" : ""}`}> 
                        <a id="botonLinkWhapp" style={{width:"100%"}} href="https://wa.me/6681316676" target="_blank"> 
                            <img src="./Images/whatsapp.png" style={{
                                width:"50px", height:"50px"
                            }}/>
                                <h3 className="CotizarTxt">Cotizar</h3>
                                </a>
                            </div>
                         
                       </div> 
                     
                </div>
                <div className="ImageWrapSolarSerdan">
                    <div className="SolarSerdanImageEmpresa">
                        <img ref={imagen3} src="./Images/Encabezado Solar Serdán-02-01.png" className={`imgSizeSolarSerdan ${image3IsVisible ? "imgSizeSolarSerdanAnimated" : ""}`} alt="" />
                    </div>
                </div>
            </div>
        </div>

  
    );
}

export default SolarSerdan;
